export const LIST_DEFAULT_ORDER_BY = '-created_at';
export const KANBAN_DEFAULT_ORDER_BY = 'sort_order';

export const BACKLOG_ORDER_OPTIONS = [
  { value: 'sort_order', label: 'Manual' },
  { value: '-created_at', label: 'Newest' },
  { value: 'created_at', label: 'Oldest' },
  { value: 'title', label: 'Title A-Z' },
  { value: '-title', label: 'Title Z-A' },
  { value: 'priority', label: 'Priority' },
  { value: '-due_date', label: 'Due date' },
] as const;

/** List opens newest-first; board stays manual so cards can be ranked. */
export function defaultWorkListOrderBy(
  layout: 'list' | 'kanban' | undefined,
  orderBy?: string,
): string {
  if (orderBy) return orderBy;
  return layout === 'kanban' ? KANBAN_DEFAULT_ORDER_BY : LIST_DEFAULT_ORDER_BY;
}

/** Board always ranks manually. List keeps a chosen sort, else newest. */
export function orderByForLayoutSwitch(next: 'list' | 'kanban', current?: string): string {
  if (next === 'kanban') return KANBAN_DEFAULT_ORDER_BY;
  if (!current || current === KANBAN_DEFAULT_ORDER_BY) return LIST_DEFAULT_ORDER_BY;
  return current;
}

export const ASSIGNED_ORDER_OPTIONS = [
  { value: 'due_date', label: 'Due date' },
  { value: 'priority', label: 'Priority' },
  { value: '-created_at', label: 'Newest' },
  { value: 'focus', label: 'Focus' },
] as const;
